export enum GoToKey {
  WHATSAPP_BYPASS = 'whatsapp-bypass',
  COMPRATINO = 'compratino',
  SIGN_UP_V2 = 'sign-up-v2',
}

export type GoToLink = {
  url: string
  target?: string
}

export type GoToDictionary = {
  [key in GoToKey]: {
    default: GoToLink
    [key: string]: GoToLink
  }
}
